import { Box } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import { GridColumnAggregateEnum } from "../../../common/enums/GridColumnAggregateEnum";
import "./Renderers.css";

export default function AggregateCellRenderer(params: ICellRendererParams) {
    const aggregateValue = params.node.group
        ? params.value
        : undefined;
    const aggregate = aggregateValue?.aggregate;
    const value = aggregateValue?.value;
    const decimalPlaces = aggregateValue?.decimalPlaces ?? 2;

    return (
        <Box sx={{ fontWeight: 700 }}>
            {typeof value === "number"
                ? aggregate === GridColumnAggregateEnum.Sum ?
                    `${value.toLocaleString("en-US", { minimumFractionDigits: decimalPlaces })} (Sum)` :
                    aggregate === GridColumnAggregateEnum.Average ?
                        `${value.toLocaleString("en-US", { minimumFractionDigits: decimalPlaces })} (Avg)` :
                        aggregate === GridColumnAggregateEnum.Count ?
                            `Count: ${value.toLocaleString("en-US")}` :
                            aggregate === GridColumnAggregateEnum.Min ?
                                `${value.toLocaleString("en-US", { minimumFractionDigits: decimalPlaces })} (Min)` :
                                aggregate === GridColumnAggregateEnum.Max ?
                                    `${value.toLocaleString("en-US", { minimumFractionDigits: decimalPlaces })} (Max)` :
                                    ""
                : ""
            }
        </Box>
    );
}